const langEN = {
    "GAS_FEES" : "Nebulas Network Gas Fees",
    "TX_WARNING" : "Warning! Nebulas Transaction times under stress are currently unknown.",
    "COLLECT" : "Collect",
    "COLLECT_DESCRIPTION" : "Collect digital assets to your heart's content! Each card is randomly generated, and contains a unique ID, which corresponds to specific stats and characteristics.",
    "BATTLE_HEADER" : "Battle",
    "TRADE" : "Trade",
    "GET_COLLECTIBLES" : "Get your collectibles!",
    "PLEASE_WAIT" : "Please wait ...",
    "VS" : "VS",
    "BATTLE_NOW" : "Battle Now",
    "CREATE_AUCTION" : "Create an Auction",
    "TRADE_DESCRIPTION" : "Have a highly rated and unique card? That could be potentially profitable! Name your price and attract a potential buyer through an auction.",
    "BATTLE_DESCRIPTION" : "Battle and level-up the cards you own! With every victory, you'll acquire a new card. But beware, a loss means you lose a card! Higher rated cards are more valuable, so battling could be very rewarding.",
    "BANNER_HEADER" : "Digitize Your Art on Blockchain!",
    "BRAND_HEADER" : "BATTLE BLOCKS",
    "BRAND_SUBHEADER" : "Battle Ready Collectable Digital Assets on Blockchain",
    "LOADING" : "Loading ...",
    "CARDS_CREATED" : "Cards Created",
    "PENDING_TRANSACTION" : "Pending Transaction",
    "SAVE" : "Save",
    "USER_LOADING" : "User Loading ...",
    "CARDS_LOADING" : "Cards Loading ...",
    "BATTLE_CARDS" : "Battle Cards",
    "WINS" : "Wins",
    "LOSSES" : "Losses",
    "CARD_ONLY" : "Card",
    "LEVEL" : "Level",
    "TOTAL" : "Total",
    "NO_CARDS" : "You don't own any cards",
    "INSTALL_EXTENSION" : "<strong>Hey!</strong> Please install and login to the <a href='https://github.com/ChengOrangeJu/WebExtensionWallet' target='_blank'>Nebulas Web Extension Wallet</a> to use the Battle Blocks service.",
    "NEBULAS_ERROR" : "<strong>Warning!</strong> There were 1 or more errors while loading data from the Nebulas Blockchain, you might need to reload.",
    "ERROR_MESSAGE" : "Error Message",
    "ACCOUNT" : "Account",
    "CREATED_ON" : "Created On",
    "NEW" : "New",
    "NOTHING_TO_SEE" : "Nothing to see ...",
    "COMPLETE" : "Complete",
    "CREATE" : "Create",
    "CLOSE" : "Close",
    "PRICE_IN_NAS" : "Price in NAS",
    "NO_CARDS" : "No Card Availale",
    "NAME" : "Name",
    "SCORE" : "Score",
    "LEVEL" : "Level",
    "BET" : "Bet",
    "SUBMIT" : "Submit",

    // About Page
    "ABOUT_HEADER" : "About Battle Blocks",
    "ABOUT" : "Battle Blocks® is a digital asset card game created on the <a href='#'>Nebulas</a> blockchain. All your assets are stored and secured by blockchain technology, making it easy and safe to buy, trade and battle with digital trading cards.",
    "TOKENS_HEADER" : "Battle Tokens",
    "TOKENS" : "Earn 5 Battle tokens with every victory. Use your tokens to levelup your cards, and other cool things (in development). Battle tokens will be redeemable for an NRC-20 equivalent, transfer date to be announced.",
    "GEN_0_HEADER" : "Generation-0 Cards",
    "GEN_0" : "Every generation will have a limited supply, and have advantages over the succeeding generation. Generation-0 is capped at 5,000 cards and will have access to unique abilities, and skills that give them an edge over the younger competitors.",
    "GEN_X_HEADER" : "Generation-X Cards",
    "GEN_X" : "Generation-X cards will only be available for top performers, which can be viewed via the Leaderboards page, and whether they decide to auction their earnings. These cards will have new art, and new skills not available in any other generation.",
    "FEES_HEADER" : "Battle Blocks Fees",
    "FEES_1" : "There are currently no fees, aside from the Nebulas Network Gas Fees.",
    "FEES_2" : "Auctions will have fees, depending on limited edition cards, or User sale prices.",
    "SUBJECT_TO_CHANGE" : "* Prices are subject to change.",

    // Footer
    "FOOTER" : {
      "MISSION" : "Mission",
      "MISSION_TEXT" : "Redefine and innovate on Blockchain based digital ownership, while raising the bar for quality, artistry, entertainment and fun.",
      "EMAIL_TEXT" : "Email here for inquiries",
      "USEFUL_LINKS" : "Useful Links",
      "RULES" : "Rules",
      "ABOUT" : "About",
      "BATTLES" : "Battles",
      "AUCTIONS" : "Auctions",
      "LEADERBOARDS" : "Leaderboards",
      "TERMS_OF_USE" : "Terms of Use",
      "SOCIAL" : "Social",
      "CONTRACT" : "Contract",
    },

    // Auction
    "AUCTION" : {
      "CREATE" : "Create Auction",
      "LOADING" : "Auctions loading ...",
      "NONE" : "No Auctions Available",
      "SOLD" : "Sold",
      "PRICE" : "Price",
      "CREATED_ON" : "Created On",
      "BUY" : "Buy",
      "ALERT_TEXT" : "Select 1 Card you'd like to place in Auction.",
      "ALERT_SUBTEXT" : "Create an Auction for no extra charge, aside from Nebulas Network Gas Fees.",
      "VIEWER" : "Auction Viewer"
    },

    // Battle
    "BATTLE" : {
        "CREATE" : "Create Battle",
        "FILTER" : "Filter Battles",
        "MY_BTLS" : "My Battles",
        "ALL_BTLS" : "All Battles",
        "OPEN_BTLS" : "Open Battles",
        "COMP_BTLS" : "Complete Battles",
        "ALL_SCORES" : "All Scores",
        "LOADING" : "Battles Loading ...",
        "NO_BTLS" : "No Battles Available",
        "TEAM_SCORE" : "Team Score",
        "NOT_COMPLETE" : "This battle is not complete.",
        "BATTLE_NOW" : "Battle Now",
        "SEE_RESULTS" : "See Results",
        "CHALLENGER_WON" : "The challenger won this battle.",
        "YOU_CHALLENGER_WON" : "You challenged and won this battle.",
        "OWNER_WON" : "The owner won this battle.",
        "YOU_OWNER_WON" : "You created and won this battle.",
        "COMPLETE" : "This battle is not complete.",
        "CANCELLED" : "This battle was cancelled.",
        "COMMENCE" : "Commence",
        "CANNOT_EXCEED" : " Your score cannot exceed the owner's score by more than 50 points.",
        "YOUR_SCORE" : "Your score",
        "OWNER_SCORE" : "Owner score",
        "CREATE_ALERT_TEXT" : "Select 3 of Your Best Cards, plus 1 Bet Card for Battle!",
        "CREATE_ALERT_SUBTEXT" : "Create a Battle for no extra charge, aside from Nebulas Network Gas Fees.",
        "COMMENCE_ALERT_TEXT" : "Select 3 of Your Best Cards, plus 1 Bet Card to Commence Battle!",
        "COMMENCE_ALERT_SUBTEXT" : "Commence Battle for no extra charge, aside from Nebulas Network Gas Fees.",
        "COMMENCE_BTL" : "Commence Battle",
        "OWNER" : "Owner",
        "OPPONENT" : "Opponent",
        "ONE" : "One",
        "TWO" : "Two",
        "THREE" : "Three",
        "BATTLE" : "Battle",
        "WON" : "Won"
    },

    // Rules
    "RULES" : {
        "CARD_SCORES" : "Card Scores",
        "SCORE_DETAILS" : "Each card is composed of <strong>Power Stats</strong>, <strong>Power Modifiers</strong> and <strong>Power Attributes</strong>. For basic - individual card scores, all the <strong>Power Stats</strong> are added together, with a +5 per level. Head-to-head battle rules and scoring is a little different, and is described below.",
        "POWER_STATS" : "Basic Power Stats",
        "SP" : "Speed",
        "ST" : "Strength",
        "DF" : "Defense",
        "SA" : "Stamina",
        "POWER_MODIFIERS" : "Power Modifiers",
        "TYPE" : "Type - Healer, Mystic, Luminous, Warrior, Elemental, Magician.",
        "LEVEL" : "Level - Increases by 1 with every battle victory.",
        "POWER_ATTRS" : "Power Attributes",
        "IN_DEV" : "In Development ...",
        "BATTLE_RULES" : "Battle Rules",
        "RULES_DESC" : "Battles take place in two steps. First, a user must initaite a battle, and then wait for an opponent. Second, an opponent must choose to commence battle from the existing initiated battles. Currently, all battles are 3 vs. 3, with 1 bet card. Each user must select 3 cards, and 1 bet card they are accepting to lose upon defeat. If they win, they will acquire the bet card of their opponenet. Each battle will consist of 3 - 1 vs. 1 battles, where battles scores are compiled by the order in which your cards were chosen. E.g. - your first chosen card, will battle against your opponents first chosen card, your second, against their second, etc. The winner of the battle is the user with more victories, e.g. best of 3. The winner will recieve a level up for the new card, and for their own bet card, additionally, the user will receive 5 battle tokens.",
        "BATTLE_SCORES" : "Battle Scores",
        "AP" : "AP: Attack Points - Strength x Speed",
        "DP" : "DP: Damage Points - AP / Opponent's Defense",
        "BT" : "BT: Battle Time - Opponent's Stamina / DP",
        "SCORE_MOD" : "Score Modifications",
        "MOD_LEVEL" : "Level: +5 per level on overall score",
        "HEALER" : "Type: Healer = +5 Stamina",
        "WARRIOR" : "Type: Warrior = +5 Defense",
        "MYSTIC" : "Type: Mystic = +5 Speed",
        "MAGICIAN" : "Type: Magician = +5 Speed",
        "LUMINOUS" : "Type: Luminous = +5 Strength",
        "ELEMENTAL" : "Type: Elemental = +5 Strength",
        "BTL_OUTCOME" : "Battle Outcome",
        "BTL_OUTCOME_DESC" : "Lower BT (Battle Time) Scores win. (How many attacks it takes a card to beat another card.)",
        "AUCTION_RULES" : "Auction Rules",
        "AUCTION_RULES_DESC" : "You are allowed to sell and buy cards for any amount of ether you wish. A card in auction will be locked until it is sold. If an auction expires before the card could be sold, the owner must unlock the card before it could be auctioned or battled again."
    },

    // Terms
    "TERMS" : {
        "TOU" : "Terms of Use",
        "TOU_DESC" : "By using our service you agree that you are solely responsible for any gains or losses, and that you have decided to interact with this product voluntarily and under this explicit agreement. You agree that Apollo Protocol ® is an experimental blockchain product with specific laws and regulation differing from country to country, and you agree to abide by the laws in which you are required to, and reside in. The experimental and speculative nature of blockchain technology make it impossible to insure any future profit or stability, and therefore, you agree that by interacting with such technology you can afford to lose any monetary value invested. You acknowledge that this product is still in development, and specific pieces of code and functionality are subject to change.",
        "OWNERSHIP" : "Ownership",
        "OWNERSHIP_DESC" : "You are the owner of the data that you create, and have stored in your account. All Battle Blocks ® are stored on the Nebulas Blockchain as data. The data maps to the images, and though you own the cards, you do not own the right to define the rules by which the images can or cannot be used. Your ownership is defined by the specific card, and the strengths, weaknesses and experience built into that card. Battle Blocks ® owns and maintains the quality of the art, images, and can change or ammend the future direction they take.",
        "PROMISE" : "Promise To You",
        "PROMISE_DESC" : "Our promise to you is to do our utmost to create the highest quality product possible, and to have an ongoing dialogue with you about what works and what doesn't work. We will be engaging in an exploration of technology, and play for the benefit of all of the Apollo Protocol ® users. We look forward to growing with you and developing awesome products that you love! Please enjoy, and feel free to contact us with any questions or ideas you may have. Game on :)"
    },

    // Leaderboard 
    "LEADERBOARD" : {
        "FIRST" : "1st Place Prize",
        "SECOND" : "2nd Place Prize",
        "THIRD" : "3rd Place Prize",
        "SHOWING" : "Showing 20 of",
        "USERS" : "Users",
        "RULES" : "<strong>Rules:</strong> Do not battle yourself with dummy accounts where you are sure to win. You will be disqualified if caught.",
        "NO_LEADERS" : " No Leaders Available",
        "LOADING" : "Leaders Loading ...",
        "RANK" : "Rank",
        "WINS" : "Wins",
        "LOSSES" : "Losses",
        "WIN_PERCENT" : "Win %",
        "USER" : "User"
    },

    // Card
    "CARD" : {
        "VIEWER" : "Card Viewer",
        "LEVEL_UP" : "Level Up",
        "TRANSFER" : "Transfer",
        "LEVEL_DESC" : "1 Levelup requires 5 Tokens",
        "TOKENS" : "Battle Tokens"
    }

};




export default langEN;


// WEBPACK FOOTER //
// ./src/util/translations/lang_en.js